import books from '../../images/books.png';
import budget from '../../images/budget.png';
import todo from '../../images/todo.png';

const ProjectsData = [
  {
    title: 'Todo List App',
    gitHub: 'https://github.com/wayungi/ToDoListApp',
    live: 'https://soft-malabi-1a9e7c.netlify.app/',
    description: [
      "A web app designed to keep track of complete and incomplete tasks.",
      "Users can add or delete tasks. Tasks can also be marked as complete or incomplete.",
      "Built with JavaScript, HTML, CSS and Webpack."
    ],
    skills: ['Javascript', 'HTML', 'CSS'],
    image: todo,
  },

  {
    title: 'Book Manager',
    gitHub: 'https://github.com/wayungi/Awesome_books_es6_2',
    live: 'https://wayungi.github.io/Awesome_books_es6_2/',
    description: [
      "Awesome books is a SPA (Single Page Application) which stores books and their authors.",
      "The app has three pages where a user can add book details, view added books, and a contact information page. Added books can also be deleted.",
      "Built with JavaScript, HTML and CSS" 
    ],
    skills: ["JavaScript", "HTML", "CSS"],
    image: books,
  },
  {
    title: 'Budget App',
    gitHub: 'https://github.com/wayungi/budget_app',
    live: 'https://budget-app-ei4z.onrender.com',
    description: [
      "Budegt App is a web application built to keep track of expenses. Expenses can be group under categories and each category can have a maximum limit set.",
      "Once the expenses exceed the maximum monthly limit, an email notification is sent to the user.  Built with Ruby on rails, HTML, CSS, Flexbox & CSS grid"
    ],
    skills: ['Ruby on Rails', 'Flexbox', 'CSS Grid'],
    image: budget,
  },
];

export default ProjectsData;
